import React from 'react'
import { getCgiUrl } from '../../helpers/url'
import { BaseWidgetProps, ConfigurablePropsFromDescription, type WidgetDescription } from '../../helpers/widget'
import { useVoteToDisableUserActions } from '../../redux/current-viewer'
import Area from '../Area'
import { SparqlTriggerExecutor } from '../SparqlTriggerExecutor'
import { type ViewerConfig } from '../Viewer'
import { usePubsub } from '../../redux/pubsub'

const widgetOptions = [
  {
    label: 'app config json',
    name: 'appConfigJSON',
    type: 'json',
  }
] as const satisfies WidgetDescription['variables']

export const componentWidgetDescriptor = {
  label: 'Component Widget [UNSTABLE]',
  name: 'Component', // without "Widget" because that's already added when hovering
  component: ComponentWidget,
  variables: widgetOptions,
} as const satisfies WidgetDescription

type WidgetProps
  = BaseWidgetProps
  & ConfigurablePropsFromDescription<typeof widgetOptions>

type LastApplied = {
  config?: ViewerConfig
}

const lastAppliedInit: LastApplied = {config: undefined}

export function ComponentWidget(props: WidgetProps) {
  const voteToDisableUserActions = useVoteToDisableUserActions()
  const [, publish] = usePubsub()
  const lastApplied = React.useRef<LastApplied>(lastAppliedInit)

  if (!props.appConfigJSON) return (
    <div>
      Provide an app config
    </div>
  )

  const componentConfig = props.appConfigJSON as ViewerConfig // not yet parsing if valid

  if (lastApplied.current.config !== componentConfig) {

    console.log('component: applying new config')
    lastApplied.current.config = componentConfig

    if (componentConfig.parameterValues) {
      const initComponentVars = JSON.parse(componentConfig.parameterValues) as Record<string, string>
      for (const key in initComponentVars) {
        publish(key, initComponentVars[key])
      }
    }

  }

  return (<>
    {componentConfig.triggers.map(trigger => (
      <SparqlTriggerExecutor
        signalIsFetching={(isFetching) => {
          if (trigger.voteForUserActionsDisabledWhenLoading)
            voteToDisableUserActions(trigger.label, isFetching)
        }}
        key={trigger.label}
        templateId={trigger.label}
        endpoint={getCgiUrl('sparql', props.repoName, props.repoURL, props.localRepoURL)}
        sparqlTemplate={trigger.sparqlQuery}
        pubVars={props.pubsub}
        publish={props.publish}
      />))}
    <Area {...props}
      notEditable
      config={(componentConfig as ViewerConfig).mainArea}
      index={0}
    />
  </>)
}